import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { size } from 'lodash';
import { getClassNameGenerator } from 'helper/className';

export class Portal extends Component {

  static className = 'esk-portal';
  static getClassName = getClassNameGenerator(Portal.className);

  static childContextTypes = {
    registerPortalComponent: PropTypes.func,
    unregisterPortalComponent: PropTypes.func,
    mountIntoPortal: PropTypes.func
  };

  getChildContext = () => {
    return {
      registerPortalComponent: this._registerPortalComponent,
      unregisterPortalComponent: this._unmountFromPortal,
      mountIntoPortal: this._mountIntoPortal
    };
  }

  _portalContainerNode;

  _portalNodes = new Map();

  render() {
    return (
      <div className={Portal.getClassName('wrapper', true)}>
        {this.props.children}
        <div
          className={Portal.className}
          ref={this._setPortalRef}
        />
      </div>
    );
  }

  _registerPortalComponent = (component) => {
    if (this._portalNodes.has(component)) {
      return;
    }
    const containerNode = window.document.createElement('div');
    this._portalContainerNode.appendChild(containerNode);
    this._portalNodes.set(component, containerNode);
  }

  _mountIntoPortal = (parentComponent, element) => {
    $('body').addClass('modal-open');
    const node = this._portalNodes.get(parentComponent);
    ReactDOM.unstable_renderSubtreeIntoContainer(parentComponent, element, node);
  }

  _unmountFromPortal = (component) => {
    const node = this._portalNodes.get(component);
    ReactDOM.unmountComponentAtNode(node);
    this._portalContainerNode.removeChild(node);
    this._portalNodes.delete(component);

    if (size(this._portalContainerNode.children) === 0) {
      $('body').removeClass('modal-open');
    }
  }

  _setPortalRef = (portalNode) => { this._portalContainerNode = portalNode; }

}
